import React from 'react';

const Footer = props => (
    <div className="Footer">
      <footer>
        <div className="tabs is-centered">
          <ul>
            <li><a href={ '/login' }>Feedback -- Software Enterprise </a></li>
          </ul>
        </div>
      </footer>
    </div>
);

export default Footer;
